
export default function ItemImageSVG(){
  return (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M0.416687 9.91668V0.0833435H10.25V9.91668H0.416687ZM11.0834 4.58334V0.0833435H15.5834V4.58334H11.0834ZM12.5334 3.13334H14.1334V1.53334H12.5334V3.13334ZM1.86669 8.46668H8.80002V1.53334H1.86669V8.46668ZM2.66669 7.00001H8.00002L6.25002 4.66668L5.00002 6.33334L4.06669 5.11668L2.66669 7.00001ZM11.0834 9.91668V5.41668H15.5834V9.91668H11.0834ZM12.5334 8.46668H14.1334V6.86668H12.5334V8.46668Z" fill="#172128"/>
    </svg>

  )
}

